"use strict";
import { emit } from "../eventBus.ts";
import { isNetworkNoiseError } from "../isNetworkError.js";
export const logs = [];
const LOG_STORAGE_KEY = "zocial_logs";
const MAX_LOGS = 100;
function stringifyValue(value) {
  if (typeof value === "string") return value;
  if (value instanceof Error) return value.stack || `${value.name}: ${value.message}`;
  if (value === null) return "null";
  if (typeof value === "undefined") return "undefined";
  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch (e) {
      return String(value);
    }
  }
  return String(value);
}
function serializeArgs(args) {
  if (!args.length) return "";
  const first = args[0];
  if (typeof first === "string" && args.length > 1 && /%[sdifoOjc%]/.test(first)) {
    let i = 1;
    const formatted = first.replace(/%([sdifoOjc%])/g, (match, spec) => {
      if (spec === "%") return "%";
      if (i >= args.length) return match;
      const value = args[i++];
      return spec === "c" ? "" : stringifyValue(value);
    });
    return [formatted, ...args.slice(i).map(stringifyValue)].join(" ");
  }
  return args.map(stringifyValue).join(" ");
}
function logToStored(log) {
  return {
    type: log.type,
    time: log.time,
    message: typeof log.message === "string" ? log.message : serializeArgs(log.args)
  };
}
const channelLabel = ZOCIAL_CHANNEL === "prod" ? "Production" : "Development";
export const banner = String.raw`=====    Zocial
  //     Version ${ZOCIAL_VERSION}
=====    Built for ${channelLabel}`;
export function clearLogs() {
  logs.length = 0;
  emit("clearConsole");
  if (ZOCIAL_IS_BROWSER) {
    try {
      localStorage.removeItem(LOG_STORAGE_KEY);
    } catch (e) {
    }
  }
}
if (ZOCIAL_IS_BROWSER) {
  let saveNow = function() {
    try {
      localStorage.setItem(LOG_STORAGE_KEY, JSON.stringify(logs.map(logToStored)));
    } catch (e) {
    }
  }, persist = function() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(saveNow, 1e3);
  }, add = function(log) {
    logs.push(log);
    if (logs.length > MAX_LOGS) {
      let idx = logs.findIndex((l) => l.type !== "error" && l.type !== "warn");
      if (idx === -1) idx = 0;
      logs.splice(idx, 1);
    }
    emit("console", log);
    persist();
  };
  var saveNow2 = saveNow, persist2 = persist, add2 = add;
  try {
    const stored = localStorage.getItem(LOG_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed)) {
        for (const entry of parsed.slice(-MAX_LOGS)) {
          logs.push({ type: entry.type, time: entry.time, args: [], message: entry.message });
        }
      }
    }
  } catch (e) {
  }
  let saveTimer;
  globalThis.addEventListener("pagehide", saveNow);
  console.info(banner);
  globalThis.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    const detail = reason && reason.stack || reason && reason.message || String(reason);
    const isNetworkNoise = isNetworkNoiseError(reason);
    add({
      type: isNetworkNoise ? "warn" : "error",
      args: ["Uncaught (in promise): " + detail],
      time: Date.now(),
      stack: reason && reason.stack
    });
    event.preventDefault();
  });
  globalThis.addEventListener("error", (event) => {
    const err = event.error;
    const detail = err && err.stack || err && err.message || event.message || String(err);
    add({
      type: "error",
      args: [detail],
      time: Date.now(),
      stack: err && err.stack
    });
  });
  globalThis.console = new Proxy(console, {
    get(target, key) {
      const real = target[key];
      if (typeof real === "function" && typeof key === "string") {
        return function(...args) {
          const log = {
            type: key,
            args,
            time: Date.now(),
            stack: new Error().stack
          };
          add(log);
          return real.call(this, ...args);
        };
      }
    }
  });
}
